<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <div class="close-button">
        <img
          src="assets/administrator/Close.svg"
          alt="close"
          class="icon"
          @click="closeModal"
        />
      </div>
      <div class="wrapper-details">
        <div class="wrapper-info">
          <p class="title">{{ delivery?.name ?? "" }}</p>
          <div class="information">
            <p class="bold">Fecha</p>
            <p>{{ delivery?.deliveryDate ?? "" }}</p>
            <p class="bold">Cliente</p>
            <p>{{ delivery?.cient ?? "" }}</p>
            <p class="bold">Mensaje</p>
            <p class="full">
              {{ delivery?.message ?? "" }}
            </p>
          </div>
        </div>
        <div class="wrapper-file approved-files">
          <div class="first-info">
            <p class="yellow-text">Archivos aprobados</p>
            <div class="info-right">
              <p class="light-text">2</p>
            </div>
          </div>
          <div class="line"></div>
          <div name="slide">
            <ul class="secondary-info">
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
              <li class="file-item">
                <p class="light-text">nombre del archivo</p>
                <p class="light-text center">png</p>
                <p class="light-text center">10MB</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Delivery } from "@/business/deliveries/domain/deliveries";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalDeliveryDetails",
  props: {
    delivery: {
      type: Object as () => Delivery | null,
      required: true,
    },
  },
  setup(props, context) {
    function closeModal() {
      context.emit("close");
    }

    return {
      closeModal,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/admin/deliveries/styles/modalDeliveryDetailsStyle";
</style>
